import type { WalletAccount } from '../../wallets/walletAccount';
import { DYNAMIC_WAAS_METADATA } from '../constants';

type IsWaasWalletAccountParams = {
  walletAccount: WalletAccount;
};

/**
 * This function determines whether the provided wallet account is a Dynamic
 * WaaS wallet account.
 *
 * @param params.walletAccount - The wallet account to check.
 * @returns True if the wallet account is a WaaS wallet account, false otherwise.
  * @notInstrumented
 */
export const isWaasWalletAccount = ({
  walletAccount,
}: IsWaasWalletAccountParams): boolean => {
  return walletAccount.walletProviderKey.includes(
    DYNAMIC_WAAS_METADATA.normalizedWalletName
  );
};
